export const ExternalLinkWcagAttributes = {
    target: "_blank",
    rel: "noopener noreferrer",
  };